import PropTypes from 'prop-types';
import { FormHelperText, makeStyles, Typography } from '@material-ui/core';
import classNames from 'classnames';
import ActionButton from '../actionButton';
import { ACTION_BUTTON_TYPES } from '../actionButton/config';
import { VOTE_MAP } from './config';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  buttons: {
    display: 'flex',
  },
  labelWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: spacing(2),
  },
  iconButton: {
    marginRight: 8,
    width: 56,
    height: 40,
    borderColor: primary.bluish5,
    '& g path': {
      fill: `${primary.bluish5} !important`,
    },
  },
  errorMessage: {
    bottom: -20,
  },
  vote: {
    borderColor: primary.bluish1,
    '& g path': {
      fill: `${primary.bluish1} !important`,
    },
  },
}));

const VoteField = ({
  translations,
  field = {},
  vote = null,
  errorMessage = '',
  hasError = false,
  onChange,
}) => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.labelWrapper}>
        <Typography variant="body2">
          {translations[field.translationKey].label}
        </Typography>
      </div>
      <div className={classes.buttons}>
        <ActionButton
          className={classNames(classes.iconButton, {
            [classes.vote]: vote === VOTE_MAP.APPROVE,
          })}
          type={ACTION_BUTTON_TYPES.VOTE_FOR}
          onClickHandler={() => onChange(VOTE_MAP.APPROVE)}
          isSquared
        />
        <ActionButton
          className={classNames(classes.iconButton, {
            [classes.vote]: vote === VOTE_MAP.REJECT,
          })}
          type={ACTION_BUTTON_TYPES.VOTE_AGAINST}
          onClickHandler={() => onChange(VOTE_MAP.REJECT)}
          isSquared
        />
      </div>
      {hasError && errorMessage && (
        <FormHelperText className={classes.errorMessage} error={hasError}>
          {errorMessage}
        </FormHelperText>
      )}
    </div>
  );
};

VoteField.propTypes = {
  translations: PropTypes.object.isRequired,
  vote: PropTypes.string,
  field: PropTypes.object,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default VoteField;
